// Claude: Add/Edit plan modal extracted to SellerSubscriptionPlanModal.tsx 10-Apr-2026; added grid columns 23-04-2026
import {
  Box,
  Button,
  Flex,
  Text,
} from "@chakra-ui/react";
import { Modal, Table } from "antd";
import SellerSubscriptionPlanModal from "./SellerModals/SellerSubscriptionPlanModal";
import React, { useEffect, useState } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import {
  AdminAddOrganiser,
  SellerSubscriptionPlan,
} from "../../Interface/AdminInterfaces";
import { useToastWrapper } from "../../Wrapper/toastWrapper";
import { AdminAPI } from "../../Apis/adminAPI";
import { AdminSellerAPI } from "../../Apis/adminSellerAPI";
import Loader from "../../Components/Loader/Loader";
import Pagination from "../../Components/Pagination/Pagination";
import { errorHandler } from "../../Utils/handler";
import { validateEmail } from "../../Utils/Validator";
import { useDispatch, useSelector } from "react-redux";
import {
  resetForm,
  setDigitalAssetsLimit,
  setSellerTagsLimit,
  setIsActive,
  setPendingMeetingsLimit,
  setPlanName,
  setRfxLimit,
  setRfxResponsePendingLimit,
  setSubscriptionValue,
  setCurrency,
  setSubscriptions,
} from "../../redux/slices/sellerSubscriptionSlice"; // Claude: renamed 08-Apr-2026; rfxLimit 10-Apr-2026; new fields 20-04-2026; closedMeetingsLimit removed 23-04-2026

type Props = {};

const mandatoryFields = [
  "planName",
  // "emailSearch",
  // "relevanceMapping",
  // "notesFeature",
  // "sellerTagsLimit",
  // "pendingMeetingsLimit",
  // "digitalAssetsLimit",
  // "closedMeetingsLimit",
  // "promoteTopListing",
  // "isChatAllowed",
  // "isAnnouncementsAllowed",
];

const Subscriptions = (props: Props) => {
  const PAGESIZE = 10;

  const { subscriptions, ...planDetails } = useSelector(
    (state: any) => state.sellerSubscription
  );

  const dispatch = useDispatch();

  const [loading, setLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const showModal = () => setIsModalVisible(true);

  const handleOk = () => {
    setIsModalVisible(false);
    setViewOnly(false);
    dispatch(resetForm());
  };

  const [total, setTotal] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [deleteid, setDeleteId] = useState("");

  const [newData, setNewData] = useState<AdminAddOrganiser>({
    organizerPersonName: "",
    organizerCompanyName: "",
    organizerPersonEmail: "",
    organizerPersonPhoneNumber: "",
  });

  const [edit, setEdit] = useState(false);
  const [editId, setEditId] = useState("");
  const [usageCount, setUsageCount] = useState<number | null>(null);
  const [isUsageModalOpen, setIsUsageModalOpen] = useState(false);
  const [viewOnly, setViewOnly] = useState(false);

  const handleChange = (e: any) => {
    setNewData({
      ...newData,
      [e.target.name]: e.target.value,
    });
  };

  const [data, setData] = useState<SellerSubscriptionPlan[]>([]);

  const handleDelete = async (key: any) => {
    setLoading(true);
    try {
      const res = await AdminAPI.deleteSellerSubscription(key);
      if (res) success("Plan deleted successfully", "");
      getData();
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  // Claude: fetch usage count — block edit/delete if sellers associated, else proceed directly 26-04-2026
  const fetchUsageAndPrompt = async (planId: string, action: 'edit' | 'delete') => {
    setLoading(true);
    try {
      const res = await AdminSellerAPI.getSellerSubscriptionUsage(planId);
      const count = res.data.count;
      setDeleteId(planId);
      if (count > 0) {
        setUsageCount(count);
        setIsUsageModalOpen(true);
      } else {
        if (action === 'edit') {
          setEdit(true);
          setActivePlanEdit(planId);
          showModal();
        } else {
          handleDelete(planId);
        }
      }
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  const handleViewPlan = () => {
    setIsUsageModalOpen(false);
    setUsageCount(null);
    setViewOnly(true);
    setActivePlanEdit(deleteid);
    showModal();
  };

  const setActivePlanEdit = (planId: string) => {
    const plan = subscriptions.find((item: any) => item._id === planId);
    if (plan) {
      setEditId(planId);
      dispatch(setPlanName(plan.planName));
      dispatch(setSellerTagsLimit(String(plan.sellerTagsLimit ?? 0)));
      dispatch(setPendingMeetingsLimit(String(plan.pendingMeetingsLimit ?? 0)));
      dispatch(setDigitalAssetsLimit(String(plan.digitalAssetsLimit ?? 0)));
      dispatch(setRfxLimit(String(plan.rfxLimit ?? 0)));
      dispatch(setRfxResponsePendingLimit(String(plan.rfxResponsePendingLimit ?? 0)));
      dispatch(setSubscriptionValue(String(plan.subscriptionValue ?? 0)));
      dispatch(setCurrency(plan.currency ?? ''));
      dispatch(setIsActive(plan.isActive));
    }
  };

  const columns = [
    { title: "Plan Name", dataIndex: "planName", key: "planName" },
    { title: "Value", dataIndex: "subscriptionValue", key: "subscriptionValue", render: (val: any) => val ?? 0 },
    { title: "Currency", dataIndex: "currency", key: "currency", render: (val: any) => val || "—" },
    { title: "RFX Limit", dataIndex: "rfxLimit", key: "rfxLimit", render: (val: any) => val ?? 0 },
    { title: "Active", dataIndex: "isActive", key: "isActive", render: (val: boolean) => (val ? "Yes" : "No") },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (_: any, object: any) => (
        <>
          <Flex gap={1}>
            <Button
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              h={"100%"}
              background={"primary.main"}
              color={"white"}
              px={3}
              py={1}
              _hover={{ background: "#2E7D32", color: "white" }}
              onClick={() => fetchUsageAndPrompt(object._id, 'edit')}
            >
              Edit
            </Button>
            <Button
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              h={"100%"}
              background={"secondary.light"}
              color={"secondary.main"}
              px={3}
              py={1}
              _hover={{ background: "#C62828", color: "white" }}
              onClick={() => fetchUsageAndPrompt(object._id, 'delete')}
            >
              Delete
            </Button>
          </Flex>
        </>
      ),
    },
  ];

  const { error, success } = useToastWrapper();

  const validate = () => {
    if (
      mandatoryFields.some(
        (field) => !planDetails[field as keyof SellerSubscriptionPlan]
      )
    ) {
      error("Please fill all the mandatory fields", "");
      return false;
    }

    return true;
  };

  const clearData = () => {
    setNewData({
      organizerPersonName: "",
      organizerCompanyName: "",
      organizerPersonEmail: "",
      organizerPersonPhoneNumber: "",
    });
  };

  // Claude: fetch all platform-level subscriptions (no eventId) 19-02-2026
  const getData = async () => {
    setLoading(true);
    try {
      const res = await AdminAPI.getSellerSubscriptions();
      dispatch(setSubscriptions(res.data.data.subscriptions));
    } catch (err) {
      error(errorHandler(err));
    } finally {
      setLoading(false);
    }
  };

  // Claude: parse all numeric limit fields before sending to backend 21-04-2026
  const buildSellerPayload = () => ({
    ...planDetails,
    rfxLimit: parseInt(planDetails.rfxLimit),
    rfxResponsePendingLimit: parseInt(planDetails.rfxResponsePendingLimit),
    pendingMeetingsLimit: parseInt(planDetails.pendingMeetingsLimit),
    digitalAssetsLimit: parseInt(planDetails.digitalAssetsLimit),
    sellerTagsLimit: parseInt(planDetails.sellerTagsLimit),
    subscriptionValue: parseFloat(planDetails.subscriptionValue) || 0,
  });

  const handleSubmit = async () => {
    if (!validate()) return;
    setLoading(true);
    if (edit) {
      try {
        const res = await AdminAPI.updateSellerSubscriptionPlan(editId, buildSellerPayload());
        dispatch(resetForm());
        handleOk();
        getData();
        success("Plan Edited Successfully", "");
        setEdit(false);
        setEditId("");
      } catch (err) {
        error(errorHandler(err));
      } finally {
        setLoading(false);
      }
    } else {
      try {
        const res = await AdminAPI.addSellerSubscriptionPlan(buildSellerPayload());
        dispatch(resetForm());
        handleOk();
        getData();
        success("Plan Added Successfully", "");
      } catch (err) {
        error(errorHandler(err));
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    getData();
  }, [currentPage]);

  return (
    <div className="p-4">
      {loading ? <Loader /> : null}
      {/* Claude: plan-in-use blocking modal — view only when sellers are associated 26-04-2026 */}
      <Modal
        title="Plan In Use"
        footer={null}
        onCancel={() => { setIsUsageModalOpen(false); setUsageCount(null); }}
        open={isUsageModalOpen}
      >
        <Text my={5} mt={8}>
          {usageCount === 1
            ? `1 seller is associated with this plan.`
            : `${usageCount ?? 0} sellers are associated with this plan.`}{" "}
          You can only view the plan.
        </Text>
        <Flex justifyContent={"space-between"}>
          <Button
            h={"100%"} background={"gray.200"} color={"gray.700"} px={3} py={1}
            _hover={{ background: "gray.300" }}
            onClick={() => { setIsUsageModalOpen(false); setUsageCount(null); }}
          >
            Cancel
          </Button>
          <Button
            h={"100%"} background={"primary.main"} color={"white"} px={3} py={1}
            _hover={{ background: "#2E7D32", color: "white" }}
            onClick={handleViewPlan}
          >
            View
          </Button>
        </Flex>
      </Modal>

      {/* Claude: extracted to SellerSubscriptionPlanModal 10-Apr-2026 */}
      <SellerSubscriptionPlanModal
        isOpen={isModalVisible}
        onClose={handleOk}
        edit={edit}
        onSubmit={handleSubmit}
        loading={loading}
        viewOnly={viewOnly}
      />
      <Flex alignItems="center" gap={2} mt={"10px"}>
        <Text size={"lg"} fontWeight={600}>
          Seller Subscription Plan
        </Text>
        <Flex gap={3}>
          {/* <Input
              placeholder="Search Organiser"
              type="text"
              border={"1px solid"}
              outline={"none"}
              _focus={{ outline: "none", border: "1px solid" }}
              h={"35px"}
              w={"200px"}
              px={2}
              borderColor={"gray.300"}
            /> */}
          <Button
            size="sm"
            fontSize="xs"
            h={"28px"}
            background={"#0E122F"}
            color={"white"}
            px={3}
            gap={2}
            _hover={{ background: "#2E7D32" }}
            onClick={() => {
              setEdit(false);
              clearData();
              setEditId("");
              showModal();
            }}
          >
            <AiOutlinePlus /> Add Plan
          </Button>
          {/* <Button
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              h={"100%"}
              background={"primary.main"}
              color={"white"}
              px={3}
            >
              Import
            </Button> */}
        </Flex>
      </Flex>
      {/* <Box>
          {total === 0 ? (
            <Text>No Organiser Companies Found</Text>
          ) : (
            <Text>Total Organiser Companies: {total}</Text>
          )}
        </Box> */}
      <Box mt={5} sx={{ "& .ant-table": { fontSize: "12px" }, "& .ant-table-cell": { fontSize: "12px" } }}>
        <Table
          size="small"
          style={{ width: "100%" }}
          tableLayout="fixed"
          dataSource={subscriptions}
          bordered
          columns={columns}
          pagination={false}
          rowKey="_id"
        />
        <Flex justifyContent={"end"}>
          <Pagination
            current={currentPage}
            total={total}
            onChange={(number) => {
              setCurrentPage(number);
            }}
            pageSize={PAGESIZE}
          />
        </Flex>
      </Box>
    </div>
  );
};

export default Subscriptions;
